import * as XLSX from 'xlsx';

/**
 * Exportuje podatke o plaćanjima škola u Excel fajl
 * Boji "plaćene" redove u zeleno (dodatna kolona za status)
 */
export const exportPlacanjaToExcel = (data, fileName) => {
  const mappedData = data.map((row) => ({
    Škola: row.school_name,
    Telefon: row.phone,
    Email: row.email,
    Lokacija: row.location_name,
    Učenika: row.student_count,
    'Broj računa': row.broj_racuna,
    Datum: row.datum_placanja,
    'Broj izvoda': row.broj_izvoda,
    Napomena: row.napomena,
    Status: row.payment_exists ? 'PLAĆENO' : 'NIJE PLAĆENO'
  }));

  const worksheet = XLSX.utils.json_to_sheet(mappedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Placanja');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
